// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1afrT","col":"styles_col__Zyk1S","actions":"styles_actions__1cNTY","conflict":"styles_conflict__1XT4_"};